import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import ArrowIcon from "@/components/icons/arrow-icon";
import ProfilePicture from "@/components/user/profile-picture";
import { AttendedMember, EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadAttendedMembersProps {
  event: EventRead;
  title: string;
  type: "honoredMembers" | "requests" | "absents" | "attendedMembers";
}
export const EventReadAttendedMembers: React.FC<EventReadAttendedMembersProps> = t0 => {
  const $ = _c(19);
  const {
    event,
    title,
    type
  } = t0;
  const [showAttendees, setShowAttendees] = useState(false);
  const members = event[type as keyof EventRead] as Array<AttendedMember>;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-6" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${title} (${members.length})`;
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="font-bold uppercase">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showAttendees) {
    t4 = () => setShowAttendees(!showAttendees);
    $[3] = showAttendees;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `transition-transform duration-200 ${!showAttendees ? "rotate-180" : ""}`;
  let t6;
  if ($[5] !== t5) {
    t6 = <ArrowIcon size={20} className={t5} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <button onClick={t4} className="p-2 hover:bg-gray-100 rounded-full transition-colors">{t6}</button>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7) {
    t8 = <div className="flex justify-between items-center">{t3}{t7}</div>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== members || $[14] !== showAttendees) {
    t9 = showAttendees && <div className="flex mt-4 pl-4 gap-y-2 justify-left flex-wrap">{members.map(_temp)}</div>;
    $[13] = members;
    $[14] = showAttendees;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <>{t1}{t8}{t9}</>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
function _temp(t0, index) {
  const {
    firstName,
    lastName,
    avatar
  } = t0;
  return <ProfilePicture key={index} size={32} mobileSize={45} firstName={firstName} lastName={lastName} src={avatar?.urls?.avatar_md} alt={`${firstName[0]}. ${lastName}`} className="-ml-2 md:!text-[14px] text-base" withTooltip={true} />;
}